import { useDispatch, useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import {
  changeCurrentLine,
  changeDealData,
  removeTemporaryDealId,
  updatePlannerSettings,
} from 'store/dealManagement/reducer';
import { fetchAndUpdatePoiPoints } from 'store/dealManagement/actions';
import { cancelFunctions } from 'utils/cancelFunctions';
import {
  resetCategoryFilters,
  resetServicesChanged,
  resetServicesSearchQuery,
  updateAvailableNonMediaServices,
  updateSelectedNonMediaServices,
} from 'store/nonMediaServices/reducer';
import { Store } from '../../types/Store.types';
import { Line } from '../../types/Deal.types';

export type UseLineSelect = { selectLine: (line: Line) => void };

export const useLineSelect = (): UseLineSelect => {
  const dispatch = useDispatch();
  const currentDealSummary = useSelector((state: Store) => state.dealManagement.commonDeal.summary);

  const selectLine = (line: Line): void => {
    const isClientSideAssetFiltering =
      !!line.proximity.plannerPoi.length ||
      !!line.proximity.openStreetMapPoi.length ||
      !isEmpty(line.segment?.selectedSegments);

    dispatch(changeCurrentLine(line.id));
    dispatch(removeTemporaryDealId());
    dispatch(changeDealData({ summary: currentDealSummary }));
    dispatch(fetchAndUpdatePoiPoints(cancelFunctions, isClientSideAssetFiltering));
    dispatch(updatePlannerSettings({ filteredAssetsIds: {} }));
    dispatch(updateSelectedNonMediaServices({ selectedNonMediaServices: [] }));
    dispatch(updateAvailableNonMediaServices({ nonMediaServices: [] }));
    dispatch(resetServicesChanged());
    dispatch(resetCategoryFilters());
    dispatch(resetServicesSearchQuery());
  };

  return {
    selectLine,
  };
};
